%ref {
	display: inline-block;
	width: 12px;
	height: 12px;
	margin-right: 5px;
}

.container {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 10px;
	color: #555;
	a {
		color: inherit !important;
	}
	> p {
		font-family: 'Ringside', sans-serif;
		font-size: 14px;
		line-height: 14px;
		.punts {
			@extend %ref;
			background-color: #0b69f7;
			border: 2px solid #fff;
			border-radius: 50%;
		}
		.franja {
			@extend %ref;
			background-color: #001366;
			opacity: 0.2;
		}
	}
}
